<template>
  <div id="tank-bar">
    <svg
      id="tank-progress"
      width="600"
      height="300"
    >
      <!-- <defs
        id="defs4259"
      >
        <linearGradient
          id="linearGradient4212"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1323.7033,-493.98198)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient3190"
        >
          <stop
            id="stop3192"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="0"
          />
          <stop
            id="stop3968"
            offset="0.5"
            style="stop-color:#000000;stop-opacity:0;"
          />
          <stop
            id="stop3194"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="1"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient4214"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1326.2991,-514.64796)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient4232"
        >
          <stop
            id="stop4234"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="0"
          />
          <stop
            id="stop4236"
            offset="0.5"
            style="stop-color:#000000;stop-opacity:0;"
          />
          <stop
            id="stop4238"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="1"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient3196"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
        />
        <linearGradient
          id="linearGradient4241"
        >
          <stop
            id="stop4243"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="0"
          />
          <stop
            id="stop4245"
            offset="0.5"
            style="stop-color:#000000;stop-opacity:0;"
          />
          <stop
            id="stop4247"
            style="stop-color:#000000;stop-opacity:0.69999999;"
            offset="1"
          />
        </linearGradient>
        <linearGradient
          id="linearGradient4335"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient4338"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient4352"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
        />
        <linearGradient
          id="linearGradient4354"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient4356"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient4368"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
        />
        <linearGradient
          id="linearGradient4370"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient4372"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient3040"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
        />
        <linearGradient
          id="linearGradient3042"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient3044"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient3054"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
        />
        <linearGradient
          id="linearGradient3056"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient3058"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
        <linearGradient
          id="linearGradient3070"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-197.66791,415.22205)"
          x1="-844.51868"
          y1="383.60803"
          x2="-1045.0846"
          y2="383.60803"
        />
        <linearGradient
          id="linearGradient3072"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-773.41323,-332.38318)"
          x1="770.45898"
          y1="-336.1423"
          x2="855.55798"
          y2="-336.1423"
        />
        <linearGradient
          id="linearGradient3074"
          inkscape:collect="always"
          xlink:href="#linearGradient3190"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.27240002,0,0,0.27240002,-774.12032,-338.01259)"
          x1="760.74548"
          y1="-295.25781"
          x2="870.46326"
          y2="-295.25781"
        />
      </defs> -->

      <g
        id="layer1"
        inkscape:label="Layer 1"
        inkscape:groupmode="layer"
        transform="translate(0,0)"
      >
        <g
          id="g3060"
        >
          <g
            id="g4347"
            style="fill:#2a7fff"
            class="progress-content"
          >
            <rect
              id="rect3188-6"
              style="fill:#2a7fff;fill-opacity:1;stroke:#000000;stroke-width:0.38486162;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="530.565132"
              height="250.31514"
              x="0"
              y="40"
              ry="18.9609261"
              rx="48"
            />
            <rect
              id="rect4092-9"
              style="fill:#2a7fff;fill-opacity:1;stroke:#000000;stroke-width:0.08591466;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="64.095057"
              height="28.1851549"
              x="350"
              y="12"
            />
            <rect
              id="rect4092-7-9"
              style="fill:#2a7fff;fill-opacity:1;stroke:#000000;stroke-width:0.06990233;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="84.817225"
              height="6.6841459"
              x="340"
              y="5"
            />
          </g>
          <!-- <g
            id="g4340"
            transform="translate(0,0)"
          >
            <rect
              id="rect3188"
              style="fill:url(#linearGradient3070);fill-opacity:1;stroke:#000000;stroke-width:0.38486159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="530.565132"
              height="250.31514"
              x="0"
              y="40"
              ry="18.9609261"
              rx="48"
            />
            <rect
              id="rect4092"
              style="fill:url(#linearGradient3072);fill-opacity:1;stroke:#000000;stroke-width:0.08591466;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="64.095057"
              height="28.1851549"
              x="350"
              y="12"
            />
            <rect
              id="rect4092-7"
              style="fill:url(#linearGradient3074);fill-opacity:1;stroke:#000000;stroke-width:0.06990233;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0"
              width="84.817225"
              height="6.6841459"
              x="340"
              y="5"
            />
          </g> -->
        </g>
      </g>
      <g
        id="layer1"
        inkscape:label="Layer 1"
        inkscape:groupmode="layer"
        transform="translate(0,0)"
      >
        <g
          id="g3060"
        >
          <g
            id="g43473"
            style="fill:#8BC34A"
            class="progress-container"
          >
            <rect
              id="rect3188-6"
              style="fill:#8BC34A;fill-opacity:1;"
              width="530.565132"
              :height="rectHeight"
              x="0"
              :y="rectY"
              ry="18.9609261"
              rx="48"
            />
          </g>
        </g>
      </g>

    </svg>
  </div>
</template>

<script>

  export default {
    name: 'TankBar',
    props: {
      value: {
        type: Number,
        required: false,
        default: 50,
      },
    },
    data () {
      return {
        rectHeight: 0,
        rectY: 0,
        topCy: 0,
      }
    },
    watch: {
      value: function (val) {
        this.updateValue(val)
      },
    },
    mounted () {
      this.updateValue(this.value)
    },
    methods: {
      updateValue (val) {
        const invertedVal = 100 - val
        this.rectHeight = (250 * (1 - (invertedVal / 100)))
        this.rectY = 250 - this.rectHeight + 40
      },
    },
  }
</script>

<style lang="scss" scoped>
.progress-container {
  stroke-width: 2px;
  .top {
    z-index: 2;
  }
}
.progress-content {
  stroke-width: 2px;
  .top {
    z-index:1;
  }
}
</style>
